/**
 * Canonical pathname for Gatsby page URLs: trim trailing whitespace; lowercase
 * unless the last segment looks like a static file (case-sensitive on CDN).
 *
 * PATHNAME_CANONICAL_INLINE_SCRIPT must stay behaviorally identical — used in gatsby-ssr head.
 */

function normalizePathname(pathname) {
  const trimmed = pathname.replace(/[\s\xa0]+$/, "");
  const last = trimmed.replace(/\/+$/, "").split("/").pop() || "";
  const looksLikeFile = /\.[a-zA-Z0-9]{1,16}$/.test(last);
  if (looksLikeFile) return trimmed;
  return trimmed.toLowerCase();
}

/** Minified IIFE for synchronous <head> execution (see gatsby-ssr.js). */
const PATHNAME_CANONICAL_INLINE_SCRIPT = `(function(){var p=location.pathname.replace(/[\\s\\xa0]+$/,"");var last=(p.replace(/\\/+$/, "").split("/").pop())||"";var file=/\\.[a-zA-Z0-9]{1,16}$/.test(last);var n=file?p:p.toLowerCase();if(n!==location.pathname)location.replace(n+location.search+location.hash);})();`;

module.exports = { normalizePathname, PATHNAME_CANONICAL_INLINE_SCRIPT };
